import { createRouter, createWebHistory } from 'vue-router';

const routes = [
  {
    path: '/',
    name: 'home',
    component: () => import(/* webpackChunkName: "home" */ '../views/Home.vue')
  },

  {
    path: '/artists',
    name: 'artists',
    component: () => import(/* webpackChunkName: "artists" */ '../views/Artists.vue')
  },

  {
    path: '/artist-type/:type',
    name: 'artists-type',
    component: () => import(/* webpackChunkName: "artists" */ '../views/Artists.vue')
  },

  {
    path: '/programme',
    name: 'programme',
    component: () => import(/* webpackChunkName: "programmes" */ '../views/Programmes.vue')
  },

  {
    path: '/syllabus',
    name: 'syllabus',
    component: () => import(/* webpackChunkName: "programmes" */ '../views/Programmes.vue')
  },

  {
    path: '/residencies',
    name: 'residencies',
    component: () => import(/* webpackChunkName: "programmes" */ '../views/Programmes.vue')
  },

  {
    path: '/residencies/archive',
    name: 'residencies-archive',
    component: () => import(/* webpackChunkName: "programmes" */ '../views/Programmes.vue')
  },

  {
    path: '/commissions',
    name: 'commissions',
    component: () => import(/* webpackChunkName: "programmes" */ '../views/Programmes.vue')
  },

  {
    path: '/commissions/archive',
    name: 'commissions-archive',
    component: () => import(/* webpackChunkName: "programmes" */ '../views/Programmes.vue')
  },

  {
    path: '/commission-type/:type',
    name: 'commission-type',
    component: () => import(/* webpackChunkName: "programmes" */ '../views/Programmes.vue')
  },

  {
    path: '/type/:type',
    name: 'event-type',
    component: () => import(/* webpackChunkName: "programmes" */ '../views/Type.vue')
  },

  {
    path: '/type/:type/:sub_type',
    name: 'event-sub-type',
    component: () => import(/* webpackChunkName: "programmes" */ '../views/Type.vue')
  },

  {
    path: '/type/:type/archive',
    name: 'event-archive',
    component: () => import(/* webpackChunkName: "programmes" */ '../views/Type.vue')
  },


  {
    path: '/young-people',
    name: 'learning',
    component: () => import(/* webpackChunkName: "learning" */ '../views/Learning.vue')
  },

  {
    path: '/library',
    name: 'library',
    component: () => import(/* webpackChunkName: "library" */ '../views/Library.vue')
  },

  {
    path: '/listen',
    name: 'listen',
    component: () => import(/* webpackChunkName: "library" */ '../views/Library.vue')
  },

  {
    path: '/opportunities',
    name: 'opportunities',
    component: () => import(/* webpackChunkName: "opportunities" */ '../views/Opportunities.vue')
  },

  {
    path: '/artist/:slug',
    name: 'artist',
    component: () => import(/* webpackChunkName: "artist" */ '../views/Artist.vue')
  },

  {
    path: '/preview-artist',
    name: 'preview-artist',
    component: () => import(/* webpackChunkName: "artist" */ '../views/Artist.vue')
  },


  {
    path: '/residency/:slug',
    name: 'residency-post',
    component: () => import(/* webpackChunkName: "post" */ '../views/Post.vue')
  },

  {
    path: '/preview-residency',
    name: 'preview-residency-post',
    component: () => import(/* webpackChunkName: "post" */ '../views/Post.vue')
  },

  {
    path: '/commission/:slug',
    name: 'commission-post',
    component: () => import(/* webpackChunkName: "post" */ '../views/Post.vue')
  },

  {
    path: '/preview-commission',
    name: 'preview-commission-post',
    component: () => import(/* webpackChunkName: "post" */ '../views/Post.vue')
  },


  {
    path: '/event/:slug',
    name: 'event-post',
    component: () => import(/* webpackChunkName: "post" */ '../views/Post.vue')
  },

  {
    path: '/preview-event',
    name: 'preview-event-post',
    component: () => import(/* webpackChunkName: "post" */ '../views/Post.vue')
  },

  {
    path: '/learning/:slug',
    name: 'workshop-post',
    component: () => import(/* webpackChunkName: "post" */ '../views/Post.vue')
  },

  {
    path: '/preview-learning',
    name: 'preview-workshop-post',
    component: () => import(/* webpackChunkName: "post" */ '../views/Post.vue')
  },

  {
    path: '/podcast/:slug',
    name: 'podcast-post',
    component: () => import(/* webpackChunkName: "post" */ '../views/Post.vue')
  },

  {
    path: '/preview-podcast',
    name: 'preview-podcast-post',
    component: () => import(/* webpackChunkName: "post" */ '../views/Post.vue')
  },

  {
    path: '/hire',
    redirect: to => ({ path: '/hire/space-hire', query: to.query, hash: to.hash }),
  },

  {
    path: '/hire/:slug',
    name: 'hire-page',
    component: () => import(/* webpackChunkName: "hire" */ '../views/Hire.vue')
  },

  {
    path: '/about',
    redirect: to => ({ path: '/about/overview', query: to.query, hash: to.hash }),
  },

  {
    path: '/about/:slug',
    name: 'about-page',
    component: () => import(/* webpackChunkName: "about" */ '../views/About.vue')
  },

 {
    path: '/event',
    redirect: to => ({ path: '/programme', query: to.query, hash: to.hash }),
  },

 {
    path: '/jobs-work-experience',
    redirect: to => ({ path: '/opportunities', query: to.query, hash: to.hash }),
  },

  {
    path: '/news/:slug',
    name: 'new-post',
    props: true,
    component: () => import(/* webpackChunkName: "news" */ '../views/New.vue')
  },


  {
    path: '/shop',
    name: 'shop',
    component: () => import(/* webpackChunkName: "shop" */ '../views/Shop.vue')
  },

  {
    path: '/product/:slug',
    name: 'product',
    props: true,
    component: () => import(/* webpackChunkName: "product" */ '../views/Product.vue')
  },

  {
    path: '/preview-product',
    name: 'preview-product',
    props: true,
    component: () => import(/* webpackChunkName: "product" */ '../views/Product.vue')
  },

  {
    path: '/product-category/:slug',
    name: 'product-category',
    props: true,
    component: () => import(/* webpackChunkName: "shop" */ '../views/Shop.vue')
  },

  {
    path: '/support-us',
    name: 'support',
    component: () => import(/* webpackChunkName: "support" */ '../views/Support.vue')
  },

  {
    path: '/search',
    name: 'search',
    component: () => import(/* webpackChunkName: "search" */ '../views/Search.vue')
  },

  {
    path: '/:slug',
    name: 'page',
    props: true,
    component: () => import(/* webpackChunkName: "page" */ '../views/Page.vue')
  },

  {
    path: '/preview-page',
    name: 'preview-page',
    props: true,
    component: () => import(/* webpackChunkName: "page" */ '../views/Page.vue')
  },

  {
    path: '/preview-home',
    name: 'preview-home',
    component: () => import(/* webpackChunkName: "home" */ '../views/Home.vue')
  },

  {
    path: '/:catchAll(.*)',
    name: 'not-found',
    component: () => import(/* webpackChunkName: "not-found" */ '../views/NotFound.vue')
  },
]

let base_url = '/';
if (process.env.NODE_ENV === 'production') base_url = '/';

const router = createRouter({
  history: createWebHistory(base_url),
  routes
});

export default router;
